import { render, staticRenderFns } from "./SubmitSong.vue?vue&type=template&id=6b72d4a4&scoped=true&"
import script from "./SubmitSong.vue?vue&type=script&lang=js&"
export * from "./SubmitSong.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSong.vue?vue&type=style&index=0&id=6b72d4a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72d4a4",
  null
  
)

export default component.exports